<div class="loadingdiv">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
</div>